import { Zone } from 'store/api-slice/types'
import { useResolutions } from 'store/resolutions'
import { Color } from 'styles/types'
import { PriceWrapper } from './styles'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Price from 'components/shared/Price'
import { useZones } from 'utils/hooks/useZones'
import { FormattedMessage } from 'react-intl'

interface TicketTypeRadioZonesAndPriceProps {
    price: number
    priceColor: Color
    zone: Zone
    hasSmallerSizeImages?: boolean
    hasFadeOutImages?: boolean
    numberOfDays: number
    hasPriceHidden: boolean
    hasDarkMode?: boolean
}

const TicketTypeRadioZonesAndPrice = ({
    price,
    priceColor,
    zone,
    hasSmallerSizeImages,
    hasFadeOutImages,
    numberOfDays,
    hasPriceHidden,
    hasDarkMode,
}: TicketTypeRadioZonesAndPriceProps) => {
    const { isTablet } = useResolutions()
    const { logotypes } = useZones({
        zone,
        mode: hasDarkMode || hasFadeOutImages ? 'mono' : 'light',
    })

    return (
        <Box direction="row" align="center" justify="flex-end" gap={16}>
            {!isTablet &&
                logotypes.map((item, index) => (
                    <img
                        src={item}
                        alt="zone logo"
                        key={index}
                        height={hasSmallerSizeImages ? 40 : 42}
                    />
                ))}
            {!hasPriceHidden && (
                <PriceWrapper ml={[16, 24]} align="flex-end">
                    <Price value={price} size="heading2" color={priceColor} />
                    {numberOfDays > 1 && (
                        <Text variant="body" color="grayscale_800" ml={4}>
                            (
                            <FormattedMessage
                                id="global.plurals.days"
                                defaultMessage="{days, plural, few {# dni} many {# dni} other {# dnia}}"
                                values={{
                                    days: numberOfDays,
                                }}
                            />
                            )
                        </Text>
                    )}
                </PriceWrapper>
            )}
        </Box>
    )
}

export default TicketTypeRadioZonesAndPrice
